module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-project-stages-completion-d9fc42f14588f641274325affcec3438.png";